import React, { useEffect } from "react";
import Form from "react-bootstrap/Form";
import { Offcanvas } from "react-bootstrap";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import {
  GetSingle,
  Update,
  Create,
  GetAll,
} from "../../../../features/admin/customization/appsetup/Slice";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";

function Edit({ show, onHide, id, setShowError, setSuccess, setErr }) {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        reset(res?.payload?.data);
        setValue("start_date", res?.payload?.data?.start_date?.split("T")[0]);
        setValue("end_date", res?.payload?.data?.end_date?.split("T")[0]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (id !== "") {
      GetData(id);
    }
  }, [id, show]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("platform_percent_cab", data?.platform_percent_cab);
      sendData.append("cab_distance", data?.cab_distance);
      sendData.append("start_date", data?.start_date);
      sendData.append("end_date", data?.end_date);
      sendData.append("free_km", data?.free_km);
      sendData.append("minimum_free_ride_km", data?.minimum_free_ride_km);

      let response;
      if (id) {
        response = await dispatch(Update({ id: id, data: sendData }));
      } else {
        response = await dispatch(Create(sendData));
      }

      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        setSuccess(true);
        setModalShow(true);
        setTimeout(() => {
          onHide();
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
      }
    } catch (error) {
      setErr(true);
      console.error("error in Edit", error);
    }
  };

  return (
    <Offcanvas show={show} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Edit Cab SetUp</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="forms_section">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-lg-6 col-md-6 mb-3">
                {/* Platform Charges */}
                {/* <div className="form-group">
                  <Form.Label>
                    Platform Charges Per Km <sub>(for cab)</sub>
                  </Form.Label>

                  <Form.Control
                    type="number"
                    placeholder="Platform Charges Per Km (for cab)"
                    min={0}
                    step="0.01"
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e") {
                        e.preventDefault();
                      }
                    }}
                    {...register("platform_percent_cab", {
                      required: "Platform Charges Per Km (for cab) is Required",
                      min: {
                        value: 0,
                        message: "Value cannot be negative",
                      },
                      validate: (value) =>
                        value >= 0 || "Value cannot be negative",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.platform_percent_cab,
                    })}
                  />

                  {errors.platform_percent_cab && (
                    <span className="text-danger">
                      {errors.platform_percent_cab?.message}
                    </span>
                  )}
                </div> */}

                {/* Cab Distance */}
                <div className="form-group">
                  <Form.Label>Cab Nearby Distance</Form.Label>

                  <Form.Control
                    type="number"
                    placeholder="Cab Nearby Distance"
                    min={0}
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e") {
                        e.preventDefault();
                      }
                    }}
                    {...register("cab_distance", {
                      required: "Cab Nearby Distance is Required",
                      min: {
                        value: 0,
                        message: "Distance cannot be negative",
                      },
                      validate: (value) =>
                        value >= 0 || "Distance cannot be negative",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.cab_distance,
                    })}
                  />

                  {errors.cab_distance && (
                    <span className="text-danger">
                      {errors.cab_distance?.message}
                    </span>
                  )}
                </div>

                {/* <hr /> */}

                <h5 className="mt-3">Free Ride Setup</h5>

                {/* Start Date */}
                <div className="form-group">
                  <Form.Label>Free Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    {...register("start_date", {
                      required: "Start Date is required",
                      validate: (value) => {
                        const today = new Date().setHours(0, 0, 0, 0);
                        const start = new Date(value).setHours(0, 0, 0, 0);

                        if (start < today) {
                          return "Start Date cannot be in the past";
                        }
                        return true;
                      },
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.start_date,
                    })}
                  />
                  {errors.start_date && (
                    <span className="text-danger">
                      {errors.start_date?.message}
                    </span>
                  )}
                </div>

                {/* End Date */}
                <div className="form-group">
                  <Form.Label>Free End Date</Form.Label>
                  <Form.Control
                    type="date"
                    {...register("end_date", {
                      required: "End Date is required",
                      validate: (value) => {
                        const startDate = new Date(
                          getValues("start_date"),
                        ).setHours(0, 0, 0, 0);
                        const endDate = new Date(value).setHours(0, 0, 0, 0);

                        if (endDate < startDate) {
                          return "End Date cannot be before Start Date";
                        }
                        return true;
                      },
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.end_date,
                    })}
                  />
                  {errors.end_date && (
                    <span className="text-danger">
                      {errors.end_date?.message}
                    </span>
                  )}
                </div>

                {/* Free KM */}
                <div className="form-group">
                  <Form.Label>Free KM</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    placeholder="Free KM (e.g. 2.50)"
                    {...register("free_km", {
                      required: "Free KM is required",
                      valueAsNumber: true,
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.free_km,
                    })}
                  />
                  {errors.free_km && (
                    <span className="text-danger">
                      {errors.free_km?.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <Form.Label>Minimum Free Ride KM</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    placeholder="Minimum Free Ride KM"
                    {...register("minimum_free_ride_km", {
                      required: "Minimum Free Ride KM is required",
                      valueAsNumber: true,
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.minimum_free_ride_km,
                    })}
                  />
                  {errors.minimum_free_ride_km && (
                    <span className="text-danger">
                      {errors.minimum_free_ride_km?.message}
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Submit buttons */}
            <div className="form_submit_div ">
              <div className="row">
                <div className="col-lg-4 mx-auto mb-3">
                  <div className="button_group">
                    <button
                      type="button"
                      className="closebtn theme_bg"
                      onClick={() => {
                        onHide();
                      }}
                    >
                      Clear
                    </button>
                    <button
                      type="button"
                      className="addbtn"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>

        {/* Success Modal */}
        <Successfull_Modal
          message={"Cab Setup Update Successfully"}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Edit;
